import React from "react";
import "./RowCount.scss";

const changeRowCount = (e, grid) => {
  grid.handleNumberEntryChange(grid.currentPage, e.target.value);
};

export default function({ grid }) {
  return (
    <div className="page-count ml-auto">
      <div className="row-count">Rows</div>
      <select
        className="btn-count"
        onChange={e => changeRowCount(e, grid)}
        value={grid.rowsPerPage}
      >
        {Object.keys(grid.rowsPerPageOptions).map((row, indx) => (
          <option key={indx}>{row}</option>
        ))}
      </select>
    </div>
  );
}
